export const toggleArrayValue = <T>(array: T[], value: T): T[] => {
    const valueSet = new Set(array);
    if (valueSet.has(value)) {
        valueSet.delete(value);
    } else {
        valueSet.add(value);
    }

    return [...valueSet.values()];
};
